module.exports = __webpack_public_path__ + "static/media/clinician-leads-to-stroke-video-thumbnail.3dc4845d.png";